export default __webpack_public_path__ + "static/media/Gauntlets of Fearless Souls.2d99f533.jpg";